// extracted by mini-css-extract-plugin
export default {"Container":"BackgroundVideo_Container__p4WA6","Video":"BackgroundVideo_Video__aYmVg","Content":"BackgroundVideo_Content__4nYWq","SubContent":"BackgroundVideo_SubContent__sgnIO"};